if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // スワイプでのスライド切替は、サムネイルの有無に関わらず拾う
        // （スマホでサムネイル非表示の商品でも動画を自動再生させるため）
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const currentElement = event.detail.currentElement;
        if (!currentElement) return;

        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        // スワイプで表示が変わったスライドも「アクティブ」扱いにする。
        // これをしないとスマホでは動画スライドが静止画（モーダルを開くボタン）のままになり、
        // タップ → モーダル → 再生の3手を踏まないと動画が始まらない。
        this.setActiveSlide(currentElement);
      }

      // is-active を移すだけの軽い処理。スクロールや並べ替えはしない
      // （スワイプ中に勝手に位置が動くのを避けるため setActiveMedia とは分ける）
      setActiveSlide(slide) {
        if (!slide || slide.classList.contains('is-active')) return;

        this.elements.viewer.querySelectorAll('.product__media-item').forEach((element) => {
          element.classList.remove('is-active');
        });
        slide.classList.add('is-active');
        this.playActiveMedia(slide);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (!deferredMedia) return;

        deferredMedia.loadContent(false);

        // 2回目以降（読み込み済み）は loadContent が何もしないので、明示的に再生し直す。
        // 一度見た動画へスワイプで戻ってきたときも再生される。
        const video = deferredMedia.querySelector('video');
        if (!video) return;

        // 差し込んだばかりの video を、いったんレイアウトに乗せてから再生する
        void video.offsetHeight;

        // iOS 対策：再生が始まったらポスター画像（＝停止中に見えているサムネイル）を外す。
        // 貼られたままだと、再生中でも絵がサムネイルのまま固まって見えることがある。
        // 自動再生を拒否されたときはポスターを残したいので、実際に始まってから外す。
        if (video.getAttribute('poster')) {
          video.addEventListener('playing', () => video.removeAttribute('poster'), { once: true });
        }

        // スマホは純正のコントロールを外す。
        // iOS は再生中の動画に、薄暗いオーバーレイ付きのコントロールをしばらく被せる。
        // ここは短いループ動画を見せる場所なので、その覆いは邪魔になる。
        // ただし自動再生が通らなかったときは再生手段が要るので、下で戻す。
        if (!this.mql.matches) {
          video.removeAttribute('controls');
          window.setTimeout(() => {
            if (video.paused) video.setAttribute('controls', 'controls');
          }, 1500);
        }

        const played = video.play();
        if (!played) return;
        played.catch(() => {
          // 音が出る動画は自動再生を拒否されるので、ミュートして一度だけ再挑戦する
          video.muted = true;
          video.play().catch(() => {});
        });
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
